<template>
  <!-- Main content area for the website -->
  <main class="website-main">
    <!-- Top gradient wrapping the featured articles component -->
    <div class="gradient-top">
      <section class="article-detail">
        <div>
          <article class="default-text">
            <h1>Ochrana osobních údajů</h1>
            <div
              class="default-text"
              v-html="article"
            />
          </article>
        </div>
      </section>
    </div>
  </main>
</template>

<script setup>
import { onMounted, defineProps, computed } from 'vue'
import { useMicrositeStore } from '../stores/useMicrositeStore'

const props = defineProps({
  microsite: {
    type: Object,
    required: true
  },
  article: {
    type: String,
    required: true
  }
})

const micrositeStore = useMicrositeStore()

onMounted(() => {
  micrositeStore.setMicrosite(props.microsite)
})

const article = computed(() => {
  return props.article
})
</script>
